import {
  SET_CURRENT_NAVIGATION,
  NAVIGATIONS_RESET,
  SET_FIELD_REFS,
  AUTORUN_BANNER,
} from "../types";

//eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case NAVIGATIONS_RESET:
    case AUTORUN_BANNER:
    case SET_CURRENT_NAVIGATION:
      return {
        ...state,
        ...action.payload,
      };
    case SET_FIELD_REFS:
      return {
        ...state,
        fieldRefs: { ...state.fieldRefs, ...action.payload.fieldRefs },
      };
    default:
      return state;
  }
};
